module.exports = __webpack_public_path__ + "static/media/23.c161a075.jpg";